import { get } from 'lodash';

import { areSPAndIngredientSameUnit } from '@commons/utils/units';

import { ENTITY_UNITS } from '@commons/constants/units';

const MISSING_CONVERSION_CASES = {
  OK: null,
  UNIT_DIFFERENCE: 'UNIT_DIFFERENCE',
  BOTH_IN_UNIT: 'BOTH_IN_UNIT',
};

/**
 * Used to check if a warning should be displayed when editing the nutrition facts of a supplier product:
 * If both the supplier product and its ingredient are defined in unit, and there is no conversion,
 * a warning should be displayed.
 *
 * @param {Object} supplierProduct The supplier product to check
 * @returns {boolean} True if a warning should be displayed, false otherwise
 */
export const isMissingConversion = (supplierProduct) => {
  if (!supplierProduct.entityId) {
    return MISSING_CONVERSION_CASES.OK;
  }

  const entityUnit = get(supplierProduct, ['entity', 'unit'], null);

  const masterPackaging = supplierProduct.packagings.find(
    (packaging) => !packaging.masterSupplierProductPackagingId,
  );
  const SPmasterUnit = masterPackaging.unit;

  const SPAndIngredientSameUnit = areSPAndIngredientSameUnit(SPmasterUnit, entityUnit);

  if (SPAndIngredientSameUnit && entityUnit !== ENTITY_UNITS.UNIT) {
    // SP and Ingredient are both in L or Kg, no warning needed
    return MISSING_CONVERSION_CASES.OK;
  }

  let missingConversionCase = MISSING_CONVERSION_CASES.OK;

  const conversions = get(supplierProduct, ['conversions'], []);
  const hasConversions = conversions.length > 0;

  if (!SPAndIngredientSameUnit && !hasConversions) {
    missingConversionCase = MISSING_CONVERSION_CASES.UNIT_DIFFERENCE;
  } else if (SPAndIngredientSameUnit && entityUnit === ENTITY_UNITS.UNIT && !hasConversions) {
    missingConversionCase = MISSING_CONVERSION_CASES.BOTH_IN_UNIT;
  }

  return missingConversionCase;
};
